import type {FC} from 'react';
import {FleetMapView} from 'talptech-gis-components';
import Layout from '../components/Layout';

const FleetMapPage: FC = () => <Layout mainContent={<FleetMapView />} />;

export default FleetMapPage;
